module.exports = __webpack_public_path__ + "img/lg_ring_r_skip_null_0.6e76ae7c.png";